import styles from "./PersonalInfoSharlingListContainer.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";

const PersonalInfoCollection = () => (
  <div className={styles.mainContainer}>
    <div className={styles.headingContainer}>
      <h1 className={styles.title}>个人信息收集清单</h1>
    </div>

    <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>收集场景/目的</th>
            <th>收集的个人信息</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>注册及登录</td>
            <td>手机号码、电子邮箱、第三方（微信、Apple）账号信息</td>
          </tr>

          <tr>
            <td>补充账号信息</td>
            <td>头像、昵称、邮箱、性别、居住地、留学学校名称、留学入学年级、个人简介</td>
          </tr>

          <tr>
            <td>提交申请表</td>
            <td>
              中文姓名、名（拼音）、姓（拼音）、出生日期、性别、手机号、电子邮箱、护照国籍/地区、留学学校名称、留学入学年级、留学大学专业（英文）、当前就读院校（选填）、住址信息（所在地区、联系地址、邮政编码）
              <br />
              <br />
              担保人信息：中文姓名、名（拼音）、姓（拼音）、与申请人的关系、出生日期、手机号、邮箱、性别、担保人地址
              <br />
              <br />
              紧急联系人信息：中文姓名、名（拼音）、姓（拼音）、与您的关系、出生日期、手机号、邮箱、性别、紧急联系人地址
              <br />
              <br />
              根据房源政策可能需要：身份证号或护照号，护照失效时间、签证照片或扫描件、财产证明、身份证照片或扫描件、护照照片及扫描件、签证I-20或DS2019表照片或扫描件、是否携带宠物、入学时间、美国驾照号、留学大学专业中文名称、留学大学课程时间、Student
              ID
            </td>
          </tr>

          <tr>
            <td>个人信息认证</td>
            <td>身份信息（姓名、身份证号或者护照、户口本及其他身份证件信息）</td>
          </tr>

          <tr>
            <td>交房租/订金/押金</td>
            <td>
              收款方、缴费金额、入住人信息（中文姓名、姓（拼写）、名（拼写）、邮箱、手机号、留学学校、身份证号、护照号、身份证正反面图片、身份证有效期、紧急联系人手机号、公寓合同、留学生offer或在读凭证、护照首页或签证页、账单、出生日期、所在省市、详细地址）
              <br />
              <br />
              付款人信息（姓名、姓（拼写）、名（拼写）、与入住人关系、手机号、身份证号码、身份证照片、身份证有效期、户口本户主页、入住人户口本页、付款银行名称、付款银行卡号）
              <br />
              <br />
              交房租备注
            </td>
          </tr>

          <tr>
            <td>老生认证</td>
            <td>当前留学地现住房源名、邮箱、学生身份认证</td>
          </tr>

          <tr>
            <td>信息搜索与展示</td>
            <td>
              服务日志信息（浏览、点击查看、搜索查询、收藏、交易、关注分享信息、发布信息）、IP地址、浏览器类型、使用语言、客户端版本、系统版本、操作系统、设备唯一标识符、访问日期和时间
            </td>
          </tr>

          <tr>
            <td>订单管理</td>
            <td>交易订单信息、租赁合同信息、租金支付信息</td>
          </tr>

          <tr>
            <td>客服服务</td>
            <td>账户信息、订单信息、客服沟通记录、电话录音、往来邮件</td>
          </tr>

          <tr>
            <td>安全运行与风控</td>
            <td>
              设备信息（IMEI、Android
              ID、OAID、IDFA、操作系统版本、APP版本号、设备安装应用列表、设备型号）、IP地址、浏览器类型、电信运营商
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
);

export default wrapperHOC(PersonalInfoCollection, {
  componentName: "PersonalInfoCollection",
  showForChina: true,
});
